import api from '@/services/api'

export default {
    fetchCollections({params, token}) {
        return api.get(`collections/`,  {params, cancelToken: token})
            .then(response => response.data)
    },
    fetchSharedCollections(params) {
        return api.get(`collections/shared/`,  {params})
            .then(response => response.data)
    },
    getCollection(collection_id) {
        return api.get(`collections/${collection_id}/`)
            .then(response => response.data)
    },
    postCollection(collection) {
        let fd = new FormData()
        for (let key in collection) {
            if (collection[key] === null) continue;
            if (['positions', 'lotteries'].includes(key)) {
                const json_positions = JSON.stringify(collection[key]);
                fd.append(key, json_positions);
            } else {
                fd.append(key, collection[key]);
            }
        }
        return api.postForm(`collections/`,  fd)
            .then(response => response.data)
    },
    editCollection(collection) {
        return api.put(`collections/${collection.id}/`,  collection)
            .then(response => response.data)
    },
    deleteCollection(collection_id) {
        return api.delete(`collections/${collection_id}/`)
            .then(response => response.data)
    },
    togglePrepayment(data) {
        let fd = new FormData()
        for (let key in data) {
            if (data[key] === null) continue;
            fd.append(key, data[key]);
        }
        return api.putForm(`collections/${data.collection_id}/toggle_prepayment/`, fd)
            .then(response => response.data)
    },
    toggleCollected(data) {
        return api.put(`collections/${data.collection_id}/toggle_collected/`, data)
            .then(response => response.data)
    },
    toggleStop(data) {
        return api.put(`collections/${data.collection_id}/toggle_stop/`, data)
            .then(response => response.data)
    },
    actionPosition(data) {
        return api.put(`collections/${data.collection_id}/action_position/`, data)
            .then(response => response.data)
    },
    drawLottery(data) {
        return api.put(`collections/${data.collection_id}/draw_lottery/`, data)
            .then(response => response.data)
    },
    takeLottery(data) {
        return api.put(`collections/${data.collection_id}/take_lottery/`, data)
            .then(response => response.data)
    },
    sendToPurchase(data) {
        return api.put(`collections/${data.collection_id}/send_to_purchase/`, data)
            .then(response => response.data)
    },
    duplicate(data) {
        return api.post(`collections/${data.collection_id}/duplicate/`, data)
            .then(response => response.data)
    },
    setState(data) {
        return api.put(`collections/${data.collection_id}/set_state/`, data)
            .then(response => response.data)
    },
    setEdit(data) {
        return api.put(`collections/${data.id}/set_edit/`, data)
            .then(response => response.data)
    },
    toggleSorted(collection_id) {
        return api.put(`collections/${collection_id}/toggle_sorted/`, {})
            .then(response => response.data)
    },
}